const items = [
    {
        n: "01",
        title: "Photo verified",
        desc: "Every profile checked. Real humans only.",
    },
    {
        n: "02",
        title: "Hidden names",
        desc: "Names stay private until your first real-world date.",
    },
    {
        n: "03",
        title: "GDPR · default",
        desc: "Export, delete, control. Your data, your call.",
    },
    {
        n: "04",
        title: "No resale",
        desc: "We will never sell your story to advertisers. Promise.",
    },
];

export default function Privacy() {
    return (
        <section
            id="privacy"
            className="relative py-28 lg:py-36 bg-[var(--paper)]"
            data-testid="privacy-section"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                <div className="reveal max-w-5xl">
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] mb-5">
                        Sect. E — Privacy & Trust
                    </div>
                    <h2 className="font-display text-6xl lg:text-[8.5rem] leading-[0.85] tracking-tighter">
                        Privacy isn't a feature.
                        <br />
                        <span className="font-italic-serif text-[var(--hot)]">
                            It's the foundation.
                        </span>
                    </h2>
                </div>

                <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-0 border-2 border-[var(--ink)]">
                    {items.map((i, idx) => (
                        <div
                            key={i.n}
                            className={`reveal relative p-8 ${
                                idx > 0
                                    ? "md:border-l-2 border-[var(--ink)]"
                                    : ""
                            } ${idx < 2 ? "border-b-2 lg:border-b-0 border-[var(--ink)]" : ""}`}
                            style={{ transitionDelay: `${idx * 80}ms` }}
                            data-testid={`privacy-${i.n}`}
                        >
                            <div className="font-display text-6xl text-[var(--hot)] leading-none">
                                {i.n}
                            </div>
                            <h3 className="font-display text-3xl mt-7 leading-tight">
                                {i.title}
                            </h3>
                            <p className="mt-3 text-sm text-[var(--ink-soft)] leading-relaxed">
                                {i.desc}
                            </p>
                            <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--ink-soft)]">
                                ✓ verified
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
